<template>
  <div class="charts"  >
    <chart-box
      v-for="(k, i) in chartList"
      @chartListTip="getChartIdFn"
      :key="k.filedKey"
      :chartData="chartList[i]"
      :isEdit="isEdit"
    ></chart-box>
    <div class="chart-head" v-show="this.chartList3[0].filedKey==this.data1||this.chartList3[0].filedKey==this.flag1 ">
      {{this.chartList3[0].filedName}}
    </div>
    <div class="chart-cont2" ref="mianscro" v-show="this.chartList3[0].filedKey==this.data1||this.chartList3[0].filedKey==this.flag1">
      <info-code v-for="(k, i) in chartData2" :key="i.filedKey"  :chartData="chartData2[i]"></info-code>
    </div>
     <div class="chart-head" v-show="this.chartList2[0].filedKey==this.data||this.chartList2[0].filedKey==this.flag ">
      {{this.chartList2[0].filedName}}
    </div>
    <div class="chart-cont2" ref="mianscroll" v-show="this.chartList2[0].filedKey==this.data||this.chartList2[0].filedKey==this.flag">
      <info-code v-for="(k, i) in chartData" :key="i.filedKey"  :chartData="chartData[i]"></info-code>
    </div>
  </div>
</template>
<script>
import chartBox from "./components/chartBox.vue";
import infoCode from "@/module/infoCode.vue"
export default {
  props: ["isContEdit","chartListData","chartListData2","chartListData3"],
  components: { chartBox,infoCode},
  data() {
    return {
      chartList: [],
      isEdit: false,
      childChartId: "",
      getDataInterval: null,
      data:"deviceOperatingStatus",
      flag:"pointAbnormality",
      data1:"pressedState",
      flag1:"alarmInformation",
      chartList2:[],
      chartList3:[],
      info:{
         filedKey: "data",
      },
      chartData:[],
      chartData2:[]
    };
  },
  created(){
    this.chartList = this.chartListData;
    this.chartList2 = this.chartListData2;
    this.chartList3 = this.chartListData3;
     if(this.chartList2.length==0||this.chartList3.length==0){
       this.chartList2.push(this.info)
       this.chartList3.push(this.info)
     }
  },
  mounted() {
     this.getDataInterval = setInterval(() => {
     this.chartList = this.chartListData;
     this.chartList2 = this.chartListData2;
     this.chartList3 = this.chartListData3;
     //拿到压合状态 报警信息
     for (let index = 0; index < this.chartListData2.length; index++) {
       const element = this.chartListData2[index];
       if (this.chartData.length==10) {
       this.chartData.shift();
       }
      this.chartData.push(element)
     } 
     //拿到设备运行状态 点位异常
    for (let index = 0; index < this.chartListData3.length; index++) {
      const element = this.chartListData3[index];
      if (this.chartData2.length==10) {
        this.chartData2.shift();
      }
    this.chartData2.push(element)

    //调用让DIV的滚动条自动滚动到最底部方法
    this.bottomScrollClick();
    this.bottomScroll();
    } 
    },2000)
  },
  methods: {
    getChartIdFn(id) {
      this.childChartId = id;
      console.log(id);
    },
    //让DIV的滚动条自动滚动到最底部
    bottomScrollClick() {
      this.$nextTick(() => {
        let scrollEl = this.$refs.mianscro;
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' });
      });
    },
    //让DIV的滚动条自动滚动到最底部
    bottomScroll() {
      this.$nextTick(() => {
        let scrollEl = this.$refs.mianscroll;
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' });
      });
    }
  },
  watch: {
    isContEdit(n) {
      this.isEdit = n;
    },
    chartListData:{
      handler(newValue,oldValue){
        this.chartList = newValue;
      }
    }
  },
  destroyed(){
    //清除定时器
    if (this.getDataInterval)  clearInterval(this.getDataInterval);
  }
};
</script>
<style lang="less" scoped>
.charts {
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  .chartBox {
    width: 100%;
    height: 32.5%;
  }
  
  .chart-cont2 {
    width: 100%;
    height: calc(37% - 36px);
    background: url("../../../module/images/chart-bg.png") no-repeat 0 0;
    background-size: 100% 100%;
    padding: 4px 12px 14px;
    overflow: auto;
  }

   .chart-head {
    width: 100%;
    height: 35px;
    margin-top: 9px;
    background: url("./components/images/chart-title.png") no-repeat 0 0;
    background-size: 100% 100%;
    padding-left: 20px;
    font-size: 18px;
    font-family: TitleFamily;
    color: #ffffff;
    line-height: 38px;
    /* 文字不可选取 */
    // user-select: none;
  }
}
// .charts:after{
//   content: '';
//   width: 20%; 
//   visibility: hidden;
//  }
</style>